import React, { useState, useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import HistoryTransactTable from "../history/HistoryTransactTable";
import HistorySummaryTable from "../history/HistorySummaryTable";
import { MDBTooltip } from "mdb-react-ui-kit";
import WagerDetailsModal from "./WagerDetailModal";
import HistoryDetailsModal from "./HistoryDetailModal";
import { errorHandler } from "../ErrorHandler";
import ActionDetailModal from "./ActionDetailsModal";

const HistoryModal = ({
  playerName,
  getHistoryTransactModal,
  historyTransactInfo,
  getDateUTCFormat,
  getTimeUTCFormat,
  historyFilters,
  setHistoryFilters,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  setStartDateSummary,
  startDateSummary,
  getHistorySummaryModal,
  historySummaryInfo,
  calculateDays,
  stateThisWeekButton,
  setStateThisWeekButton,
  balanceForward,
  loading,
  balanceForwardTransact,
  roBalanceForwardTransact,
  fpBalanceForwardTransact,
  showBalance,
  addCommas,
  getWagerDetailModal,
  wagerDetails,
  setWagerDetails,
  loginPlayerInfo,
  getHistoryDetailModal,
  historyDetails,
  getActionDetailModal,
  actionDetails,
  wagerErrorModal,
  getOpenBetsDetailModal,
  openBetDetails,
}) => {
  //Wager Details modal states
  const [isWagerModalOpen, setIsWagerModalOpen] = useState(false);
  const [isHistoryDetailModalOpen, setIsHistoryDetailModalOpen] =
    useState(false);
  const [isActionDetailModalOpen, setIsActionDetailModalOpen] = useState(false);
  const [gradedWager, setGradedWager] = useState(false);

  let wonAmount = [],
    lossAmount = [],
    wagers = [],
    transactions = [],
    totalWon,
    totalLoss;

  //Check Classic View checkbox checked by default when opening the new track modal
  let chkClassicView = document.getElementById("switchClassicView");
  if (chkClassicView) {
    chkClassicView.checked = historyFilters.ClassicView;
  }

  if (historyTransactInfo && historyTransactInfo.length > 0) {
    historyTransactInfo.forEach((data, i) => {
      if (data.Amount > 0) {
        wonAmount.push(parseInt(data.Amount));
      }

      if (data.Amount < 0) {
        lossAmount.push(parseInt(data.Amount));
      }

      if (
        data.TransactionType === "I" ||
        data.TransactionType === "M" ||
        data.TransactionType === "O"
      ) {
        wagers.push(data.TransactionType);
      } else {
        transactions.push(data.TransactionType);
      }
    });
  }

  totalWon = wonAmount.reduce((a, b) => a + b, 0);
  totalLoss = lossAmount.reduce((a, b) => a + b, 0);

  //Onchange para cargar los filtros
  const onChange = (e) => {
    setHistoryFilters({
      ...historyFilters,
      [e.target.name]: e.target.value,
    });
  };

  useEffect(() => {
    setHistoryFilters({
      ...historyFilters,
      StartDate: startDate,
    });
  }, [startDate]);

  useEffect(() => {
    setHistoryFilters({
      ...historyFilters,
      EndDate: endDate,
    });
  }, [endDate]);

  //RadioButton Filter Text
  const filterTextOnChange = (event) => {
    setHistoryFilters({ ...historyFilters, FilterText: event.target.value });
  };

  const showLastWeekSummary = (ThisWeek) => {
    if (!ThisWeek) {
      setStateThisWeekButton(true);
      getHistorySummaryModal(calculateDays(startDateSummary, -7), false);
    } else {
      setStateThisWeekButton(false);
      getHistorySummaryModal(calculateDays(startDateSummary, 7), false);
    }
  };

  //Validar Login del Player para colocar el botón que se requiere
  let weekButtons;
  if (stateThisWeekButton) {
    weekButtons = (
      <>
        <button
          type="button"
          className="btn btn-icon btn-info ml-2 mt-2"
          style={{
            borderRadius: "50%",
          }}
          onClick={() => showLastWeekSummary(true)}
        >
          <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="This Week">
            <i className="fas fa-redo-alt" style={{ marginTop: "3px" }}></i>
          </MDBTooltip>
        </button>
      </>
    );
  } else {
    weekButtons = (
      <>
        <button
          type="button"
          className="btn btn-icon btn-info ml-2 mt-2"
          style={{
            borderRadius: "50%",
          }}
          onClick={() => showLastWeekSummary(false)}
        >
          <MDBTooltip tag="i" wrapperProps={{ href: "#" }} title="Last Week">
            <i className="fas fa-undo-alt" style={{ marginTop: "3px" }}></i>
          </MDBTooltip>
        </button>
      </>
    );
  }

  const WAGER_TYPES = ["I", "M", "O", "S", "W", "X"];

  const openWagerDetailsModal = async (rowData) => {
    setGradedWager(false);
    try {
      if (rowData.IDTransaction > 0 || rowData.IDWager > 0) {
        if (WAGER_TYPES.includes(rowData.TransactionType)) {
          if (!rowData.Graded) {
            await getOpenBetsDetailModal(rowData.IDWager);
            setGradedWager(false);
          } else {
            await getWagerDetailModal(rowData.IDWager);
            setGradedWager(true);
          }

          setIsWagerModalOpen(true);
        } else {
          await getHistoryDetailModal(rowData.IDTransaction);
        }
      } else {
        errorHandler("No details available for this transaction");
      }
    } catch {
      return;
    }
  };

  useEffect(() => {
    if (
      !wagerErrorModal &&
      historyDetails &&
      Object.keys(historyDetails).length > 0
    ) {
      setIsHistoryDetailModalOpen(true);
    }
  }, [wagerErrorModal, historyDetails]);

  const openActionDetailModal = async (rowData) => {
    try {
      if (rowData.TicketNumber > 0) {
        await getActionDetailModal(rowData.TicketNumber);
        setIsActionDetailModalOpen(true);
      }
    } catch {
      return;
    }
  };

  // This function is called when the user clicks on Close button for clear input fields.
  const closeModal = () => {
    setHistoryFilters({
      StartDate: new Date(),
      EndDate: new Date(),
      TicketNumber: "",
      FilterText: "",
      ClassicView: true,
    });
    setStartDateSummary(new Date());
    setStateThisWeekButton(false);
  };

  return (
    <>
      <div
        className="modal fade"
        role="dialog"
        aria-labelledby="myLargeModalLabel"
        aria-hidden="false"
        data-keyboard="false"
        data-backdrop="static"
        id="historyModal"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header headerModals">
              <h5
                className="modal-title text-center w-100"
                id="myLargeModalLabel"
              >
                Player History - {playerName}
              </h5>

              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={closeModal}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div
              className="modal-body"
              style={{
                paddingTop: "5px",
                paddingBottom: "5px",
              }}
            >
              <div
                style={{
                  backgroundColor: "rgb(217, 230, 242, 0.7)",
                  borderRadius: "10px",
                  padding: "10px",
                }}
              >
                <div className="row">
                  <div className="col-12 col-lg-12 col-xl-6 mb-3 mb-lg-0">
                    <div className="d-flex flex-column flex-md-row flex-wrap align-items-center">
                      <input
                        type="text"
                        placeholder="Ticket #"
                        id="TicketNumber"
                        name="TicketNumber"
                        onChange={onChange}
                        value={historyFilters.TicketNumber}
                        className="form-control mt-1 mr-md-1"
                        style={{
                          width: "100%",
                          maxWidth: "200px",
                        }}
                      />

                      <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                          setStartDate(date);
                        }}
                        className="form-control text-center mt-1 mr-md-1"
                      />

                      <label className="mt-2 mx-2 mb-0">to</label>

                      <DatePicker
                        selected={endDate}
                        onChange={(date) => {
                          setEndDate(date);
                        }}
                        className="form-control text-center mt-1"
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-12 col-xl-5">
                    <div className="row">
                      <div className="col-6 col-md-3">
                        <div className="custom-control custom-radio custom-control-inline mt-2">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="defaultInline1"
                            name="FilterText"
                            onClick={filterTextOnChange}
                            value={""}
                            defaultChecked
                          />

                          <label
                            className="custom-control-label"
                            htmlFor="defaultInline1"
                          >
                            All
                          </label>
                        </div>
                      </div>

                      <div className="col-6 col-md-3">
                        <div className="custom-control custom-radio custom-control-inline mt-2">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="defaultInline2"
                            name="FilterText"
                            value={"W,I,X"}
                            onClick={filterTextOnChange}
                          />

                          <label
                            className="custom-control-label"
                            htmlFor="defaultInline2"
                          >
                            Wagers
                          </label>
                        </div>
                      </div>

                      <div className="col-6 col-md-3">
                        <div className="custom-control custom-radio custom-control-inline mt-2">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="defaultInline3"
                            name="FilterText"
                            onClick={filterTextOnChange}
                            value={"D,R,T"}
                          />

                          <label
                            className="custom-control-label"
                            htmlFor="defaultInline3"
                          >
                            Payments
                          </label>
                        </div>
                      </div>

                      <div className="col-6 col-md-3">
                        <div className="custom-control custom-radio custom-control-inline mt-2">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="defaultInline4"
                            name="FilterText"
                            onClick={filterTextOnChange}
                            value={"P"}
                          />

                          <label
                            className="custom-control-label"
                            htmlFor="defaultInline4"
                          >
                            Free Plays
                          </label>
                        </div>
                      </div>

                      <div className="col-6 col-md-3">
                        <div className="custom-control custom-radio custom-control-inline mt-2 mb-2">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="defaultInline5"
                            name="FilterText"
                            onClick={filterTextOnChange}
                            value={"A,C"}
                          />

                          <label
                            className="custom-control-label"
                            htmlFor="defaultInline5"
                          >
                            Adjustments
                          </label>
                        </div>
                      </div>

                      <div className="col-6 col-md-3">
                        <div className="custom-control custom-radio custom-control-inline mt-2 mb-2">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="defaultInline6"
                            name="FilterText"
                            onClick={filterTextOnChange}
                            value={"K"}
                          />

                          <label
                            className="custom-control-label"
                            htmlFor="defaultInline6"
                          >
                            Casino
                          </label>
                        </div>
                      </div>

                      <div className="col-6 col-md-3">
                        <div className="custom-control custom-radio custom-control-inline mt-2 mb-2">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="defaultInline7"
                            name="FilterText"
                            onClick={filterTextOnChange}
                            value={"H,O"}
                          />

                          <label
                            className="custom-control-label"
                            htmlFor="defaultInline7"
                          >
                            Horses
                          </label>
                        </div>
                      </div>

                      <div className="col-6 col-md-3">
                        <div className="custom-control custom-radio custom-control-inline mt-2 mb-2">
                          <input
                            type="radio"
                            className="custom-control-input"
                            id="defaultInline8"
                            name="FilterText"
                            onClick={filterTextOnChange}
                            value={"V"}
                          />

                          <label
                            className="custom-control-label"
                            htmlFor="defaultInline8"
                          >
                            Rollover
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-xl-1 d-flex align-items-center justify-content-lg-end justify-content-center mt-2 mt-lg-0">
                    {/* <div className="custom-control custom-switch mt-2 mr-3">
                            <input
                              type="checkbox"
                              className="custom-control-input"
                              id="switchClassicView"
                              name="ClassicView"
                              value={historyFilters.ClassicView}
                              onClick={(e) =>
                                handleCheckboxClassicViewChange(e)
                              }
                            />
                            <label
                              className="custom-control-label "
                              htmlFor="switchClassicView"
                            >
                              Classic View
                            </label>
                          </div> */}
                    <button
                      type="button"
                      className="btn btn-PlaceBet"
                      onClick={() => getHistoryTransactModal(true)}
                    >
                      Show
                    </button>
                  </div>
                </div>
              </div>

              <div
                className="divTables mb-1 mt-3"
                style={{
                  overflow: "auto",
                }}
              >
                <HistoryTransactTable
                  historyTransactInfo={historyTransactInfo}
                  getDateUTCFormat={getDateUTCFormat}
                  getTimeUTCFormat={getTimeUTCFormat}
                  addCommas={addCommas}
                  loading={loading}
                  balanceForwardTransact={balanceForwardTransact}
                  roBalanceForwardTransact={roBalanceForwardTransact}
                  fpBalanceForwardTransact={fpBalanceForwardTransact}
                  showBalance={showBalance}
                  openWagerDetailsModal={openWagerDetailsModal}
                  openActionDetailModal={openActionDetailModal}
                />
              </div>

              <div
                style={{
                  minHeight: "180px",
                }}
              >
                <div
                  className="col-12"
                  style={{
                    backgroundColor: "rgb(217, 230, 242, 0.7)",
                  }}
                >
                  <div className="d-flex flex-column flex-md-row flex-wrap align-items-start align-items-md-center py-2">
                    <label
                      className="mr-md-4 mb-2 mb-md-0"
                      style={{
                        color: "#006699",
                      }}
                    >
                      Weekly Statistics
                    </label>

                    <DatePicker
                      selected={startDateSummary}
                      onChange={(date) => {
                        getHistorySummaryModal(date, true);
                      }}
                      className="form-control text-center mb-2 mb-md-0 mr-md-2"
                    />

                    <div>{weekButtons}</div>
                  </div>
                </div>

                <div
                  className="divTables mb-1 mt-3"
                  style={{
                    overflow: "auto",
                  }}
                >
                  <HistorySummaryTable
                    historySummaryInfo={historySummaryInfo}
                    startDateSummary={startDateSummary}
                    addCommas={addCommas}
                    balanceForward={balanceForward}
                  />
                </div>
              </div>
            </div>

            <div className="modal-footer d-flex flex-column flex-md-row justify-content-between align-items-center">
              <div
                className="d-flex flex-wrap align-items-center text-muted mb-2 mb-md-0"
                style={{ gap: "15px" }}
              >
                <span>
                  Loaded: {transactions.length} Transaction(s) and{" "}
                  {wagers.length} Wager(s)
                </span>

                <span>Won: {addCommas(totalWon)}</span>

                <span>Loss: {addCommas(totalLoss)}</span>
              </div>

              <button
                type="button"
                className="btn btn-secondary"
                data-dismiss="modal"
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      {isWagerModalOpen && (
        <WagerDetailsModal
          onHide={() => {
            setIsWagerModalOpen(false);
            setWagerDetails({});
          }}
          selectedWager={gradedWager ? wagerDetails : openBetDetails}
          loginPlayerInfo={loginPlayerInfo}
          getDateUTCFormat={getDateUTCFormat}
        />
      )}

      {isHistoryDetailModalOpen && (
        <HistoryDetailsModal
          show={isHistoryDetailModalOpen}
          onHide={() => {
            setIsHistoryDetailModalOpen(false);
          }}
          historyDetails={historyDetails}
        />
      )}

      {isActionDetailModalOpen && (
        <ActionDetailModal
          show={isActionDetailModalOpen}
          onHide={() => {
            setIsActionDetailModalOpen(false);
          }}
          actionDetails={actionDetails}
        />
      )}
    </>
  );
};

export default HistoryModal;
